module.exports = __webpack_public_path__ + "img/pv-06.3324c90e.svg";